var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[_c('crumb',{attrs:{"prevLevel":"预警总览","current":_vm.current}}),_c('warning-list',{attrs:{"warningList":_vm.warningList,"total":_vm.warningTotalCount},on:{"current-change":_vm.loadWarnList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }